import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PictureApprovalNotificationBanner.css';
import { picturesAPI } from './services/api';

function PictureApprovalNotificationBanner({ currentUser }) {
  const { t } = useTranslation();
  const [unapprovedCount, setUnapprovedCount] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      setUnapprovedCount(0);
      return;
    }

    const loadUnapprovedCount = async () => {
      try {
        const count = await picturesAPI.getUnapprovedCount(currentUser.id);
        setUnapprovedCount(count);
      } catch (error) {
        console.error('Error loading unapproved pictures count:', error);
      }
    };

    loadUnapprovedCount();

    // Refresh count every 30 seconds
    const interval = setInterval(loadUnapprovedCount, 300000);

    return () => clearInterval(interval);
  }, [currentUser]);

  const handleClick = () => {
    setDismissed(true);
    navigate('/profile', { state: { activeTab: 'pictures' } });
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setDismissed(true);
  };

  if (!currentUser || unapprovedCount === 0 || dismissed) {
    return null;
  }

  return (
    <div className="picture-notification-banner" onClick={handleClick}>
      <span className="notification-icon">📷</span>
      <span className="notification-text">
        {t('pictureNotificationBanner.text', { count: unapprovedCount })}
      </span>
      <span className="notification-arrow">→</span>
      <button className="banner-close-btn" onClick={handleDismiss}>×</button>
    </div>
  );
}

export default PictureApprovalNotificationBanner;
